import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Paper } from "@material-ui/core";
import LoadingPosts from "../Posts/LoadingPosts";
import Post from "../Posts/Post";
import { getPosts } from "../../actions/postActions";

const useStyles = makeStyles((theme) => ({
  formTitle: {
    fontSize: "2rem",
    fontWeight: 500,
    marginBottom: "1rem",
    fontFamily: "Montserrat, sans-serif",
    color: theme.palette.text.primary,
  },

  noScrollbar: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
  },
}));

const HomeLayout = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.post.loading);
  const list = useSelector((state) => state.post.list);

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={8} md={7}>
        <Typography className={classes.formTitle}>
          Be part. Express yourself
        </Typography>

        {loading ? (
          <LoadingPosts />
        ) : (
          <div className={`${classes.noScrollbar}`}>
            {list &&
              list.map((el) => (
                <Grid className="my-4">
                  <Post key={el._id} post={el} />
                </Grid>
              ))}
          </div>
        )}
      </Grid>
    </Grid>
  );
};

export default HomeLayout;
